module.exports = __webpack_public_path__ + "static/media/undraw_web_devices_re_m8sc.4d771178.svg";